import { memo } from 'react';
import styled, { css } from 'styled-components';

interface Props {
	className?: string;
	children: React.ReactNode;
	disabled?: boolean;
}

const GreyBox = ({ children, className }: Props) => {
	return <div className={className}>{children}</div>;
};

const Memoized = memo(GreyBox);
const Styled = styled(Memoized)`
	padding: 0.5rem;
	border-radius: 4px;
	background-color: ${({ theme }) => theme.v2.color.neutral[100]};

	${({ disabled }) =>
		disabled &&
		css`
			opacity: 32%;
		`};
`;

export { Styled as GreyBox };
